<template>
  <sModal
    v-model="dialog"
    :data-qa="`modal-tender-${dataQa}`"
    :mask-closable="false"
    :title="title">
    <sButton
      slot="activator"
      :data-qa="`btn-tenders-to-${dataQa}`"
      :disabled="!!loading"
      :icon="decision ? '' : 'cross'"
      icon-size="12px"
      :loading="!!loading"
      :type="decision ? 'black' : 'text'"
      @click="open">
      {{ btnLabel }}
    </sButton>
    <SpilkaFormioMF
      v-if="dialog && newFormParams && newFormParams.formCode"
      ref="formioForm"
      class="ml-2"
      :disabled="!!loading"
      :form-params="newFormParams"
      :hide-submit="true"
      :key-draft="keyDraft"
      :show-alert="false"
      @formLoad="showTour"
      @initialized="loadForm = false"
      @submit-error="errorFormio"/>
    <div
      key="footer"
      slot="footer">
      <sButton
        :data-qa="`btn-send-${dataQa}`"
        :loading="loadForm || !!loading"
        @click="submitFormio">
        {{ decision ? $t('Tenders.ToAgree') : $t('Application.Reject') }}
      </sButton>
      <sButton
        class="ml-2"
        data-qa="btn-dialog-template-second"
        :disabled="!!loading"
        icon-class="mr-2"
        type="text"
        @click="close">
        {{ $t('Common.Close') }}
      </sButton>
      <sButton
        data-qa="save-as-draft"
        icon="diskette"
        :loading="loadForm || !!loading"
        type="text"
        @click="saveDraft">
        {{ $t('Application.SaveAsDraft') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
/**
 * Формы согласования
 */

import SpilkaFormioMF from 'components/common/SpilkaFormioMF.vue'

import { storageMixin } from 'mixins'
import formio from 'mixins/formio'
import { eventBus } from '@/main'

export default {
  name: 'TenderAgreementResult',
  mixins: [ storageMixin, formio ],
  data() {
    return {
      dialog: false,
      loadForm: true, // форма загружается
    }
  },
  methods: {
    errorFormio() {
      this.$notice.error({
        title: 'Error',
        duration: 10
      })
    },
    async showTour() {
      this.$nextTick(async () => {
        await this.$_getPropFromDBStorage('confirmTenderAgreement_tour', false)
          .then(async (viewedTour) => {
            if (viewedTour || !this.keyDraft) { return }
            eventBus.$emit('startTour', 'confirmReject')
            await this.$_savePropToDBStorage('confirmTenderAgreement_tour', true, new Date().setDate(new Date().getDate() + 180))
          })
      })
    },
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    saveDraft() {
      this.$refs.formioForm.saveDraft()
      this.$notice.info({
        title: this.$t('Application.DraftSaved'),
        duration: 10
      })
    },
    submitFormio() {
      this.$refs.formioForm.validate()
        .then((result) => {
          if (result.result) {
            this.submitValid()
          }
        })
    },
    async submitValid() {
      this.$spinner.show()
      const eventModel = {
        formCode: this.newFormParams?.formCode,
        tenderId: this.tender?.tenderId,
        diagramId: null,
        submission: JSON.stringify(this.$refs.formioForm.formData?.submission?.data ?? {}),
        components: JSON.stringify(this.$refs.formioForm.formData?.components ?? [])
      }
      this.$_formSubmission(eventModel)
        .then((result) => {
          if (result.success) {
            this.$_deletePropFromDBStorage(this.keyDraft)
            this.$emit('success')
            this.close()
          } else {
            this.$notice.error({
              title: 'result',
              dangerouslyUseHTMLString: true,
              message: JSON.stringify(result),
              showClose: true,
              progress: true,
            })
          }
        })
        .finally(() => {
          this.$spinner.close()
        })
    },
  },
  computed: {
    newFormParams() {
      return {
        ...this.formParams,
        tenderId: this.tender.tenderId
      }
    },
    title() {
      return this.decision ? this.$t('Application.ConfirmAgree') : `${this.$t('Application.WhyDecline')} ${ this.$t('Tenders.TenderApproval') }?`
    },
    btnLabel() {
      if (this.label) {
        return this.label
      }
      return this.decision ? this.$t('Tenders.ToAgree') : this.$t('Application.Reject')
    },
    keyDraft() {
      let result
      if (this.newFormParams?.formCode && this.newFormParams?.params?.length) {
        const tenderId = this.newFormParams.tenderId
        if (tenderId) { result = `${this.decision ? 'confirmTenderAgreement' : 'rejectDialog'}-${tenderId}-${this.newFormParams.formCode}-v-${this.newFormParams.version}_draft` }
      }
      return result
    },
  },
  components: {
    SpilkaFormioMF,
  },
  props: {
    tender: Object,
    /**
     * Результат согласования
     */
    decision: Boolean,
    /**
     * Название кнопки
     */
    label: {
      type: String
    },
    /**
     * Параметры Formio
     */
    formParams: {
      type: Object
    },
    loading: [Boolean, String],
    dataQa: {
      type: String,
      default: 'agree'
    }
  },
}
</script>
